module.exports = __webpack_public_path__ + "media/images/new-ui-images/notification-dot-571f7c09410517f52b82323f41124f70.svg";